module.exports = __webpack_public_path__ + "7b823787880dedfe27432267eda3cb6d.png";